import React, { useMemo } from 'react';

import mark from '../img/mark.svg';

export const Price = React.memo(
  ({ recommended, attention, title, dollar, price, fullPrice, heading, features = [], cta, onCta }) => {
    const classes = useMemo(
      () => `group flex flex-col h-full max-w-[384px] max-h-[556px] cursor-pointer gap-[31px] rounded-[32px] p-[40px] 
      transition-all duration-300 ${recommended ? 'z-10 scale-105 shadow-2xl' : 'z-0 shadow-md'}
        ${attention ? 'bg-[#F2E9E4]' : 'bg-[#F8F4F2]'}
        `,
      [recommended, attention]
    );
    return (
      <div className={classes} onClick={onCta}>
        <div className="rounded-[24px] bg-white p-[24px]">
          <span className="text-[20px] font-medium leading-[34px]">{title}</span>
          <div>
            <div className="flex space-x-[8px]">
              {dollar && <h1 className="mt-[21px] text-[16px] font-bold leading-[51px] tracking-[-1px]">{dollar}</h1>}
              <h1 className="mt-[21px] text-[36px] font-bold leading-[51px] tracking-[-1px]">
                {fullPrice && fullPrice !== price && (
                  <span className="mr-2 font-medium text-gray-300 line-through">{fullPrice}</span>
                )}
                {price}
                {/* {fullPrice && fullPrice !== price && (
                  <span className="ml-2 text-[24px] font-medium text-gray-300">
                    {`${Math.round(((Number(fullPrice) - Number(price)) / Number(fullPrice)) * 100)}% OFF`}
                  </span>
                )} */}
              </h1>
            </div>
            <span className="text-balance text-[14px] font-normal leading-[24px] text-[#454140]">{heading}</span>
          </div>
        </div>
        <div className="mt-[16px] flex flex-1 flex-col gap-[15px]">
          {features.map((feature, index) => (
            <div className="flex flex-wrap gap-[10px]" key={index}>
              <img src={mark} alt="mark" />
              <p className=" text-[16px] leading-[28px] text-[#454140]">{feature}</p>
            </div>
          ))}
        </div>
        <div className="flex h-[80px] flex-col items-center justify-between">
          <hr className="w-[100px] border-[0.5px] border-[#120A0B] opacity-30" />
          <button className="h-[50px] w-[304px] rounded-full bg-black px-[30px] text-[16px] font-bold text-white transition-all delay-200 duration-[500ms] ease-in-out active:shadow-none group-hover:bg-primary group-hover:shadow-xl">
            {cta}
          </button>
        </div>
      </div>
    );
  }
);
